import { VAT_ID } from '@constants';
import { Box, Button, Link, Typography } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';

import { getCurrentCountry } from '~/utils/countryUtils';

import Dialog from './Dialog';

export default function ImprintDialog() {
  const [open, setOpen] = React.useState(false);

  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        disableRipple
        variant="text"
        onClick={() => setOpen(true)}
        sx={{
          height: 24,
          color: 'inherit',
          '&:focus-visible': {
            outline: '2px solid currentColor',
            outlineOffset: '2px',
          },
          textDecoration: 'underline',
          textUnderlineOffset: 4,
          textDecorationThickness: 1,
        }}
      >
        <Typography component={Link}>
          <Trans i18nKey="footer.imprint.title" />
        </Typography>
      </Button>
      <Dialog
        open={open}
        handleClose={handleClose}
        showCloseIcon={false}
        maxWidth="xs"
        title={<Trans i18nKey="footer.imprint.title" />}
        body={
          <>
            <Box>
              <Typography variant="h6">
                <Trans i18nKey="footer.imprint.companyName.title" />
              </Typography>
              <Typography variant="body1">
                <Trans i18nKey="footer.imprint.companyName.content" />
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                <Trans i18nKey="footer.imprint.representedBy.title" />
              </Typography>
              <Typography variant="body1">
                <Trans i18nKey="footer.imprint.representedBy.content" />
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                <Trans i18nKey="footer.imprint.address.title" />
              </Typography>
              <Typography variant="body1">
                <Trans i18nKey="footer.imprint.address.content" />
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                <Trans i18nKey="footer.imprint.contact.title" />
              </Typography>
              <Typography variant="body1">
                <Trans
                  i18nKey="footer.imprint.contact.content"
                  values={{ phone: getCurrentCountry().support.phone, email: getCurrentCountry().support.email }}
                  components={[
                    <Link key="phone" href={`tel:${getCurrentCountry().support.phone}`} underline="always" />,
                    <Link key="email" href={`mailto:${getCurrentCountry().support.email}`} underline="always" />,
                  ]}
                />
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                <Trans i18nKey="footer.imprint.registerEntry.title" />
              </Typography>
              <Typography variant="body1">
                <Trans i18nKey="footer.imprint.registerEntry.content" />
              </Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                <Trans i18nKey="footer.imprint.vatId" />
              </Typography>
              <Typography variant="body1">{VAT_ID}</Typography>
            </Box>
            <Box>
              <Typography variant="h6">
                <Trans i18nKey="footer.imprint.editorial.title" />
              </Typography>
              <Typography variant="body1">
                <Trans i18nKey="footer.imprint.editorial.content" />
              </Typography>
            </Box>
          </>
        }
      />
    </>
  );
}
